<template lang="html">
  <li class="dropdown auto nav-item" id="notificationsMenuRoot">
    <a href="#"
       class="nav-link"
       @click.prevent="updateNotificationsCheckpoint"
       id="dropdownMenuNotification"
       data-toggle="dropdown"
       aria-haspopup="true"
       aria-expanded="false">
      <m-icon :icon="unseenNotifications ? 'bell-active' : 'bell'" :scale="0.8" />
<!--      <font-awesome-icon :icon="!hasPending ? [ 'fas', 'bell' ] : ['fas', 'car']" class="menu-icon" />-->
      <span class="d-lg-none">Notificaciones</span>
    </a>
    <ul ref="notificationsContainer"
      class="navbar-notifications dropdown-menu dropdown-menu-right py-0"
      aria-labelledby="dropdownMenuNotification">
      <div class="navbar-notifications-header px-3 bg-light py-1">
<!--        <div class="navbar-notifications-button float-left">-->
<!--          Ver todas-->
<!--        </div>-->
        <div @click="setAllSeen"
          class="navbar-notifications-button float-right text-primary">
          Marcar todas como leídas
        </div>
      </div>
      <li v-for="noti in notifications.slice(0, maxDisplayed)"
          :key="noti.id"
          @click="goToNotification(noti)"
          class="d-flex dropdown-item navbar-notifications-item py-2 mx-0"
          :style="{'background-color': noti.read_at ? '' : '#CFE6CF'}">
        <figure v-if="!isCreditNotification(noti)" class="notification-image">
          <span class="notification-image-align-helper"></span>
          <div class="resource-image my-0"
               :style="`height: 100%; width: 100%; background-image: url(${noti.image});`" >
          </div>
        </figure>
        <div v-else class="credit-notification">
          <font-awesome-icon class="credit-icon" :icon="[ 'fas', 'dollar-sign' ]" />
        </div>
        <section class="notification-content">
          <div class="notification-text">
            {{ noti.line1 }}
          </div>
          <div class="notification-title">
            {{ noti.line2 }}
          </div>
          <div class="timestamp text-secondary">
            {{ noti.date | moment }}
          </div>
        </section>
      </li>
      <li v-if="notifications.length === 0" class="py-2">
        No hay nuevas notificaciones
      </li>
    </ul>
  </li>
</template>

<script>
import store from '@/store'
import infiniteScrollMixin from '@/mixins/infiniteScroll'
import { slugify } from 'transliteration'

/** Notification types:
 * question
 * answer
 * credit_accreditation
 * publication_follower
 * publication_hidden
 * highlight_start
 * highlight_end
 * publication_should_be_republished
 */

export default {
  mixins: [
    infiniteScrollMixin
  ],

  data: () => ({
    maxDisplayed: 7,
    step: 3,
    hasMoreNotifications: true,
    isFetching: false,
    isExpanding: false
  }),

  computed: {
    notifications: () => store.state.user.notifications,

    notificationsCheckpoint: () => store.state.user.notificationsCheckpoint,

    unseenNotifications () {
      return !this.notificationsCheckpoint && this.notifications.filter(n => !n.read_at).length > 0 ||
        this.notificationsCheckpoint && this.notifications.filter(n => Date.parse(n.date) > Date.parse(this.notificationsCheckpoint)).length > 0
    },

    normalIcon: () => '/static/icons/favicon.png',

    notificationIcon: () => '/static/icons/favicon-notification.png'
  },

  methods: {
    slugify,

    fetch () {
      if (this.isFetching || !this.hasMoreNotifications) return true

      this.isFetching = true

      return store.dispatch('user/fetchNotifications')
        .then(next => { this.hasMoreNotifications = next })
        .finally(() => { this.isFetching = false })
    },

    showMore () {
      if (this.isExpanding) return

      this.isExpanding = true
      setTimeout(() => {
        this.maxDisplayed = this.maxDisplayed + this.step
        if (this.maxDisplayed + (this.step * 2) > this.notifications.length) {
          this.fetch()
        }
        if (this.maxDisplayed > this.notifications.length) {
          this.maxDisplayed = this.notifications.length
        }
        this.isExpanding = false
      }, 200)
    },

    createURL (noti) {
      return `/${noti.resource}/${noti.resourceId}`
    },

    goToNotification (noti) {
      this.pushToDataLayer('Header', 'Notification open')
      this.$emit('click')
      store.dispatch('user/updateNotification', {
        id: noti.id,
        key: 'read_at',
        val: new Date()
      })
      if (!this.isCreditNotification(noti)) {
        const pubTitle = !!noti.line2 && slugify(noti.line2)
        this.$router.push({ name: noti.resource, params: { id: noti.resourceId, title: pubTitle } })
      } else {
        this.$router.push({ name: 'userCheckingAccount' })
      }
    },

    setAllSeen (e) {
      e.stopPropagation()
      store.dispatch('user/setAllNotificationsAsSeen')
    },

    isCreditNotification (notification) {
      return notification.type === 'credit_accreditation'
    },

    updateNotificationsCheckpoint () {
      if (!document.getElementById('notificationsMenuRoot').className.includes('show')) {
        // Notifications menu is closed, update checkpoint
        store.dispatch('user/setNotificationsCheckpoint')
        this.pushToDataLayer('User menu', 'Notifications')
      }
    }
  },

  watch: {
    unseenNotifications (newVal) {
      document.getElementById('favicon').href = newVal ? this.notificationIcon : this.normalIcon
    }
  },

  mounted () {
    this.fetch()
    this.infiniteScrollContainer = this.$refs.notificationsContainer
    this.infiniteScrollOnScrollEnd = this.showMore
    this.infiniteScrollEdge = 50
  }
}
</script>

<style lang="scss">
  @import '../../scss/breakpoints';
  @import '../../scss/colors';

  .navbar-notifications {
    width: 100%;
    font-size: 90%;
    max-height: 50vh;
    min-height: 22rem;
    overflow-y: auto;

    @media screen and (max-width: map-get($grid-breakpoints, "lg")) {
      min-height: initial;
    }

    &-header {
      height: 2rem;
      border-bottom: solid 1px #ced4da;
    }

    &-button {
      cursor: pointer;
    }

    &-item {
      display: flex;
      overflow: hidden;
      width: 100%;
      height: 133px;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      @media screen and (max-width: map-get($grid-breakpoints, "md")) {
        width: 98vw;
      }
    }

    & .notification-text {
      font-size: 1.125rem;
      white-space: normal;
      text-align: left;
      cursor: pointer;
      max-height: 54px;
      overflow: hidden;
    }

    & .notification-title {
      font-size: 1rem;
      font-weight: bold;
      color: $primary;
      text-align: left;
      cursor: pointer;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    & .timestamp {
      white-space: normal;
      text-align: left;
      cursor: pointer;
      font-weight: 400;
      font-size: 85%;
    }
  }

  .credit {
    &-notification {
      display: flex;
      margin: 0;
      width: 50px;
    }

    &-icon {
      color: $primary;
      width: 100% !important;
      height: 40%;
      align-self: center;
      text-align: center;
    }
  }

  .notification-image {
    margin: 0;
    background-color: $gray-300;
    text-align: center;
    min-width: 125px;
  }

  .notification-image-align-helper {
    display: inline-block;
    height: 100%;
    visibility: hidden;
    position:absolute;
    vertical-align: middle;
  }

  .resource-image {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    width: 100%;
    height: 100%;
  }

  .notification-content {
    display: inline-block;
    margin-top: 0.5rem;
    margin-left: 0.5rem;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  @media screen and (max-width: map-get($grid-breakpoints, "md")) {
    .notification-content {
    }
  }

  @media screen and (min-width: map-get($grid-breakpoints, "lg")) {
    .notification-content {
      width: fit-content;
    }
    .navbar-notifications {
      width: 28rem;
      font-size: 80%;

      &-header {
        font-size: 110%;
      }

      & .notification-text {
        white-space: normal;
        text-align: left;
        cursor: pointer;
      }

      & .notification-title {
        font-weight: bold;
        color: $primary;
        text-align: left;
        cursor: pointer;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      & .timestamp {
        white-space: normal;
        text-align: left;
        font-size: 100%;
        font-weight: 400;
        margin-top: 0.25rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/user/Notifications.vue